module.exports = __webpack_public_path__ + "static/media/TeamYellow.8d2cd884.png";